import { Component, type ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
  error: Error | null;
};

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  override render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#040a12',
            color: '#ff7d7d',
            fontFamily: 'system-ui, sans-serif',
            padding: 24,
            textAlign: 'center',
          }}
        >
          <div style={{ fontSize: 24, fontWeight: 800, letterSpacing: 4, textTransform: 'uppercase', marginBottom: 16 }}>
            CRITICAL SYSTEM FAILURE
          </div>
          <pre
            style={{
              background: 'rgba(255,255,255,0.04)',
              border: '1px solid rgba(255,255,255,0.1)',
              padding: 16,
              fontSize: 12,
              fontFamily: 'monospace',
              color: '#ff9b9b',
              maxWidth: 'min(640px, 90vw)',
              overflow: 'auto',
              textAlign: 'left',
            }}
          >
            {this.state.error?.message ?? 'Unknown error'}
          </pre>
        </div>
      );
    }

    return this.props.children;
  }
}
